import React from "react";
import FolderOffIcon from '@mui/icons-material/FolderOff';


export default function EmptyState({ text = 'No Data' }) {
    return (
        <div className="w-100 text-center h3 mt-3">
            <FolderOffIcon style={{ fontSize: '2.5rem', marginBottom:'6px' }} />
            <p style={{fontSize:'1rem'}}>{text}</p>
        </div>
    )
}
